var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverviewHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.8,72.6c-12.3-11.4-31.3-11.4-43.5,0l-224,208c-9.6,9-12.8,22.9-8,35.1,4.8,12.2,16.5,20.3,29.7,20.3h16v176c0,35.3,28.7,64,64,64h288c35.3,0,64-28.7,64-64v-176h16c13.2,0,25-8.1,29.8-20.3,4.8-12.2,1.6-26.2-8-35.1l-224-208ZM304,384h32c26.5,0,48,21.5,48,48v96h-128v-96c0-26.5,21.5-48,48-48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewHome);
export default __webpack_public_path__ + "static/media/overview-home.a9eb692cb1afc28619d1e8013c26d5bb.svg";
export { ForwardRef as ReactComponent };